"use client";

import { Info } from "lucide-react";
import type { Agent } from "@/lib/api";
import {
  DIRECT_MODEL_DEFAULT,
  DIRECT_VOICE_OPTIONS,
  normalizeDirectModel,
  normalizeDirectVoice,
} from "@/lib/agent-mode";
import { Select } from "@/components/ui/select";

type Props = {
  draft: Agent;
  onChange: (next: Agent) => void;
};

export function AgentEditDirectVoicePanel({ draft, onChange }: Props) {
  const model = normalizeDirectModel(draft.directModel);
  const voice = normalizeDirectVoice(draft.directVoice);

  function patch(partial: Partial<Agent>) {
    onChange({ ...draft, ...partial });
  }

  return (
    <div className="agent-conv agent-limits">
      <section className="agent-limits-card">
        <header className="agent-limits-card-head">
          <div>
            <h3 className="agent-conv-h">GPT-Live mouth</h3>
            <p className="agent-limits-lead">
              Direct uses OpenAI GPT-Live for listening and speaking. The Pulse LLM chain still
              chooses tools. Voice is fixed for the session once a call starts.
            </p>
          </div>
        </header>
        <label className="agent-perc-live-field">
          <span>Model</span>
          <input
            className="form-control"
            value={model}
            onChange={(e) => patch({ directModel: e.target.value })}
            aria-label="GPT-Live model"
          />
          <em>Allow-listed at the worker; default {DIRECT_MODEL_DEFAULT}.</em>
        </label>
        <label className="agent-perc-live-field">
          <span>Voice</span>
          <Select
            value={voice}
            onChange={(v) => patch({ directVoice: normalizeDirectVoice(v) })}
            options={DIRECT_VOICE_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
          />
        </label>
        <div className="agent-limits-note" role="note">
          <Info size={15} strokeWidth={2} aria-hidden />
          <p>
            Cartesia speed, volume, and emotion do not apply. Turns are owned by GPT-Live (no End
            of turn tab).
          </p>
        </div>
      </section>
    </div>
  );
}
